import {
    TECH_DOC_INTERNAL_TICKET_ATTACHMENTS_SAVED_ERROR,
    TECH_DOC_INTERNAL_GET_TICKET,
    TECH_DOC_INTERNAL_TICKET_ATTACHMENTS_SAVED,
    TECH_DOC_INTERNAL_TICKET_CREATED,
    TECH_DOC_INTERNAL_TICKET_LOCKED,
    TECH_DOC_INTERNAL_TICKET_LOCKED_ERROR,
    TECH_DOC_INTERNAL_TICKET_LOCKED_FATAL,
    TECH_DOC_INTERNAL_TICKET_SEND,
    TECH_DOC_INTERNAL_TICKET_UPDATED,
    TECH_DOC_INTERNAL_TICKET_SG_INFO_SEND,
    TECH_DOC_INTERNAL_TICKET_SG_INFO_ERROR,
    TECH_DOC_INTERNAL_GET_SG_INFO,
} from '../../constants/websocketCommands';
import {
    TECH_DOC_INTERNAL_TICKET_CREATE,
    TECH_DOC_INTERNAL_TICKET_RESET,
    TECH_DOC_INTERNAL_TICKET_UPDATE
} from '../../actions/techDoc/actionTechDocInternalTicket';
// import {TECH_DOC_INTERNAL_ATTACHMENTS_UPLOADING_ERROR} from '../../actions/techDoc/actionTechDocInternalAttachments';
import {TECH_DOC_INTERNAL_RESET_REDIRECT, TECH_DOC_INTERNAL_SET_LOCK_TICKET} from '../../actions/techDoc/actionTechDocInternalLockTicket';

export const techDocInternalTicket = (state = {
    correlationId: null,
    correlationIdSgInfo: null,
    isTicketLoading: false,
    isTicketCreating: false,
    created: false,
    ticket: {},
    vehicleDetail: {},
    partDetail: {},
    problemDescription: {},
    logs: [],
    messages: [],
    attachments: [],
    newAttachments: [],
    ticketReference: {},
    canTakeBack: false,
}, action) => {
    switch (action.type) {
        case TECH_DOC_INTERNAL_TICKET_RESET: {
            return Object.assign({}, state, {
                correlationId: null,
                correlationIdSgInfo: null,
                isTicketLoading: false,
                isTicketCreating: false,
                created: false,
                ticket: {},
                vehicleDetail: {},
                partDetail: {},
                problemDescription: {},
                logs: [],
                attachments: [],
                newAttachments: [],
                ticketReference: {},
                canTakeBack: false,
            });
        }
        case TECH_DOC_INTERNAL_TICKET_UPDATE:
        case TECH_DOC_INTERNAL_TICKET_CREATE: {
            const {newAttachments} = action.payload;
            return Object.assign({}, state, {
                newAttachments,
                isTicketCreating: true,
                created: false,
                isTicketLoading: true,
                vehicleDetail: {},
                partDetail: {},
                problemDescription: {},
                messages: [],
                logs: [],
                attachments: [],
                ticketReference: {},
            });
        }
        //command accepted
        case TECH_DOC_INTERNAL_TICKET_CREATED:
        case TECH_DOC_INTERNAL_TICKET_UPDATED:
        case TECH_DOC_INTERNAL_GET_TICKET: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                isTicketCreating: false,
                created: true,
                isTicketLoading: true,
                correlationId
            });
        }

        case TECH_DOC_INTERNAL_TICKET_SEND: {
            const {ticket, correlationId, vehicleDetail, partDetail, problemDescription, logs, attachments, error, messages, solutionGroupInfo, canTakeBack, documentationUpdate, storeCheckResults, ticketReference} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            if (error) {
                return Object.assign({}, state, {isTicketLoading: false, correlationId});
            }
            return Object.assign({}, state, {
                isTicketLoading: false,
                correlationId,
                ticket,
                vehicleDetail,
                partDetail,
                problemDescription,
                logs,
                attachments,
                messages,
                solutionGroupInfo,
                canTakeBack,
                documentationUpdate,
                storeCheckResults,
                ticketReference,
            });
        }
        case TECH_DOC_INTERNAL_GET_SG_INFO: {
            return Object.assign({}, state, {
                solutionGroupInfo: {}
            });
        }
        case TECH_DOC_INTERNAL_TICKET_SG_INFO_SEND: {
            const {correlationId, solutionGroupInfo} = action.payload;

            if (correlationId < state.correlationIdSgInfo) {
                return state;
            }
            return Object.assign({}, state, {
                solutionGroupInfo,
                correlationIdSgInfo: correlationId
            });
        }
        case TECH_DOC_INTERNAL_TICKET_SG_INFO_ERROR: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationIdSgInfo) {
                return state;
            }
            return Object.assign({}, state, {
                solutionGroupInfo: {},
                correlationIdSgInfo: correlationId
            });
        }
        //att done + error
        // case TECH_DOC_INTERNAL_ATTACHMENTS_UPLOADING_ERROR:
        case TECH_DOC_INTERNAL_TICKET_ATTACHMENTS_SAVED_ERROR: {
            return Object.assign({}, state, {
                newAttachments: [],
            });
        }
        case TECH_DOC_INTERNAL_TICKET_ATTACHMENTS_SAVED: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                isTicketLoading: true,
                correlationId,
                newAttachments: [],
            });
        }
        default:
            return state;
    }
};

export const techDocLockInternalTicketCheck = (state = {
    correlationId: null,
    isTicketLocking: false,
    redirect: false,
}, action) => {
    switch (action.type) {
        case TECH_DOC_INTERNAL_TICKET_LOCKED_ERROR:
        case TECH_DOC_INTERNAL_TICKET_LOCKED_FATAL: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId,
                isTicketLocking: false,
                redirect: true,
            });
        }
        case TECH_DOC_INTERNAL_RESET_REDIRECT: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case TECH_DOC_INTERNAL_TICKET_LOCKED: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case TECH_DOC_INTERNAL_SET_LOCK_TICKET: {
            const {uuid} = action.payload;
            return Object.assign({}, state, {
                isTicketLocking: true,
                redirect: false,
                uuid,
            });
        }
        default:
            return state;
    }
};
